import React from 'react'
import classNames from 'classnames'
import styles from './EcospendText.scss'

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>

export const EcospendText: React.FC<Props> = ({ className, ...rest }) => (
    <p className={classNames(styles.EcospendText, className)} {...rest} />
)